<mat-card class="matcardcontent">
    <mat-card-header>
        <mat-card-title>Lista cataloghi</mat-card-title>
    </mat-card-header>
    <mat-card-content>
<!--      <form>-->
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="Codice">
        <th [style.display]="getConfigurazione().Codice" mat-header-cell *matHeaderCellDef>Codice
          <img src="./assets/images/sort.png" (click)="manageClick('Codice')"/>
        </th>
        <td [style.display]="getConfigurazione().Codice" mat-cell *matCellDef="let catalogo"> {{catalogo.Codice}} </td>
    </ng-container>

    <ng-container matColumnDef="Nome">
        <th [style.display]="getConfigurazione().Nome" mat-header-cell *matHeaderCellDef>Nome
          <img src="./assets/images/sort.png" (click)="manageClick('Nome')"/>
        </th>
        <td [style.display]="getConfigurazione().Nome" mat-cell *matCellDef="let catalogo"> {{catalogo.Nome}} </td>
    </ng-container>

    <ng-container matColumnDef="Descrizione">
        <th [style.display]="getConfigurazione().Descrizione" mat-header-cell *matHeaderCellDef>Descrizione
          <img src="./assets/images/sort.png" (click)="manageClick('Descrizione')"/>
        </th>
        <td [style.display]="getConfigurazione().Descrizione" mat-cell *matCellDef="let catalogo"> {{catalogo.Descrizione}} </td>
    </ng-container>

    <ng-container matColumnDef="Datavalidodal">
        <th [style.display]="getConfigurazione().Datavalidodal" mat-header-cell *matHeaderCellDef>Valido dal
          <img src="./assets/images/sort.png" (click)="manageClick('Datavalidodal')"/>
        </th>
        <td [style.display]="getConfigurazione().Datavalidodal" mat-cell *matCellDef="let catalogo"> {{catalogo.Datavalidodal | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="Datavalidoal">
        <th [style.display]="getConfigurazione().Datavalidoal" mat-header-cell *matHeaderCellDef>Valido al
          <img src="./assets/images/sort.png" (click)="manageClick('Datavalidoal')"/>
        </th>
        <td [style.display]="getConfigurazione().Datavalidoal" mat-cell *matCellDef="let catalogo"> {{catalogo.Datavalidoal | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="Categoria">
        <th [style.display]="getConfigurazione().Categoria" mat-header-cell *matHeaderCellDef>Categoria
          <img src="./assets/images/sort.png" (click)="manageClick('Categoria')"/>
        </th>
        <td [style.display]="getConfigurazione().Categoria" mat-cell *matCellDef="let catalogo"> {{catalogo.Categoria}} </td>
    </ng-container>

    <ng-container matColumnDef="Codicefornitore">
        <th [style.display]="getConfigurazione().Codicefornitore" mat-header-cell *matHeaderCellDef>Codicefornitore
          <img src="./assets/images/sort.png" (click)="manageClick('Codicefornitore')"/>
        </th>
        <td [style.display]="getConfigurazione().Codicefornitore" mat-cell *matCellDef="let catalogo"> {{catalogo.Codicefornitore}} </td>
    </ng-container>

      <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Modifica </th>
          <td mat-cell *matCellDef="let catalogo">
            <mat-icon color="primary" (click)="edit(catalogo)">create</mat-icon>
          </td>
      </ng-container>

      <ng-container matColumnDef="articoli">
        <th mat-header-cell *matHeaderCellDef> Articoli </th>
        <td mat-cell *matCellDef="let catalogo">
          <mat-icon color="primary" (click)="gotoarticoli(catalogo)">list</mat-icon>
        </td>
    </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>

<!-- </form> -->
</mat-card-content>
<mat-card-actions>
  <table>
    <tr>
      <td>
        <button mat-raised-button  color="primary" (click)="new()">Nuovo catalogo</button>
      </td>
      <td>
        <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
      </td>
    </tr>
  </table>
</mat-card-actions>

</mat-card>
